import React, {
  forwardRef, FunctionComponent, ReactElement, Ref, SVGProps,
} from 'react';

import style from './style.module.scss';

interface FilmCardProps {
    image?: string
    alt?: string
    logo?: FunctionComponent<SVGProps<SVGSVGElement>>
}

export const FilmCard = forwardRef(({ image, logo: Logo, alt }: FilmCardProps, ref): ReactElement => (
  <div ref={ref as Ref<HTMLDivElement>} className={style.filmCard}>
    <div className={style.overlay} />
    <img className={style.image} alt={alt} src={image} />
    { Logo && <Logo className={style.logo} />}
  </div>
));

FilmCard.defaultProps = {
  image: undefined,
  logo: undefined,
  alt: 'film poster',
};
